import { usePage } from '@inertiajs/react'
import { useEffect } from 'react'
import { toast } from 'sonner'
import type { SharedProps } from '@/types'

function showFlash(flash: SharedProps['flash']) {
  if (flash.alert) toast.error(flash.alert)
  if (flash.notice) toast.success(flash.notice)
}

export function useFlash() {
  const { flash } = usePage<SharedProps>().props

  useEffect(() => {
    // setTimeout + cleanup prevents double-firing in React StrictMode
    const timeout = setTimeout(() => showFlash(flash), 0)
    return () => clearTimeout(timeout)
  }, [flash])
}
